import API from '@/api';
import moment from 'moment';
const Cases = API.get('Cases');
const CasesV2 = API.get('CasesV2');

export default ({
  namespaced: true,
  
  state: {
    cases: [],
    case: null,
    case_id: null,
    activeInfo: null,
    
    /* #################### CASE NOTES #################### */

    notes: [],
    note: null,
    title: null,
    activeNote: null,
    activeNoteIndex: null,

    /* #################### CASE NOTES #################### */

    health_concern: '',
    reason: '',
    case_category: '',
    case_sub_category: null,
    caseCategoryComments: '',
    pediatric_category: null,
    endorsement: '',
    last_page: null,
    history: '',
    isAssigning: false,
    assignId: null,
    form_submitted: false,

    last_menstrual_period: null,
    isSeasonalIllness: 0,
    loa: null,

    medicalCertificateQuantity: {},

    case_images: null,
    case_history: null,
    imageList: [],
    diagnoses: [],
    examinations: [],
    recommendations: [],
    medicines: [],

    pms_sync_errors: [],
    has_pms_error: false,

    symptom_checker: {},

    terminator: 0
  },

  /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

  getters: {
    cases: state => state.cases,
    case: state => state.case,
    case_id: state => state.case_id,
    activeInfo: state => state.activeInfo,
    health_concern: state => state.health_concern,
    case_images: state => state.case_images,
    case_history: state => state.case_history,    
    
    terminator: state => state.terminator,
    /* #################### CASE NOTES #################### */

    notes: state => state.notes,
    note: state => state.note,
    title: state => state.title,
    activeNote: state => state.activeNote,
    activeNoteIndex: state => state.activeNoteIndex,

    /* #################### CASE NOTES #################### */


    last_menstrual_period: state => state.last_menstrual_period,
    isSeasonalIllness: state => state.isSeasonalIllness,
    loa: state => state.loa,


    /* #################### CASE IMPORTANT INFOS #################### */

    diagnoses: state => state.diagnoses,
    examinations: state => state.examinations,
    recommendations: state => state.recommendations,
    medicines: state => state.medicines,

    /* #################### CASE IMPORTANT INFOS #################### */

    medicalCertificateQuantity: state => state.medicalCertificateQuantity,

    // case info
    reason: state => state.reason,
    case_category: state => state.case_category,
    case_sub_category: state => state.case_sub_category,
    caseCategoryComments: state => state.caseCategoryComments,
    endorsement: state => state.endorsement,
    
    // sub: state => state.sub,
    last_page: state => state.last_page,
    history: state => state.history,
    isAssigning: state => state.isAssigning,
    assignId: state => state.assignId,
    empty_fields: state => {
      var empty = 0
      if (!state.case_category) {
        empty = 1
      }       else {
        if (state.case_category == 'Pediatric') {
          if (!state.case_sub_category) {
            empty = 2
          }
        }
      }
      return empty
    },
    form_submitted: state => state.form_submitted,
    pms_sync_errors: state => state.pms_sync_errors,
    has_pms_error: state => state.has_pms_error,
    symptom_checker: state => state.symptom_checker
  },

  /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

  mutations: {
    setAssignLoading(state, value) {
      state.isAssigning = value
    },

    setTerminator (state, value) {
      state.terminator = value
    },

    setLoa(state) {
      state.loa = !state.loa
    },

    setAssignId(state, id) {
      state.assignId = id
    },

    formSubmitted(state, value) {
      state.form_submitted = value
    },

    setCases(state, cases) {
      state.cases = cases
    },

    set_pms_sync_errors(state, pms_sync_errors) {
      state.pms_sync_errors = pms_sync_errors
    },

    set_has_pms_error(state, has_pms_error) {
      state.has_pms_error = has_pms_error
    },

    setCase(state, value) {
      state.case = value
    },

    setHealthConcern(state, value) {
      state.health_concern = value
      state.activeInfo.health_concern = value
    },

    setActiveId(state, id) {
      state.case_id = id
    },

    setLmp(state, lmp) {
      state.last_menstrual_period = lmp      
    },

    setActiveInfo(state, info) {

      console.log("set case active info");
      console.log(info);

      state.activeInfo = info;
      state.health_concern = info.health_concern;
      state.reason = info.reason_for_encounter;
      state.case_category = info.case_category;
      state.case_sub_category = info.case_sub_category;
      state.caseCategoryComments = info.caseCategoryComments;
      state.last_menstrual_period  = moment(info.last_menstrual_period).format('yyyy-MM-DD');      
      state.loa = info.loa;
      state.medicalCertificateQuantity = JSON.parse(info.medicalCertificateQuantity);
      
      state.endorsement = info.endorsement;
      // state.sub = info.case_sub_category;
      state.history = info.historyOfPresentIllness;

      state.diagnoses = info.diagnoses;
      state.examinations = info.examinations;
      state.recommendations = info.recommendations;
      state.medicines = info.medicines;

      state.health_concern = info.health_concern;
      
      if (info.consultations.length > 0) {
        let consult = info.consultations[0];
        console.log('consultttt:', consult.symptom_result);
        if (consult.symptom_result != null) {
          state.symptom_checker = consult.symptom_result || {};
        }
      }

      if(!info.image_ignore) {
        if(info.case_images && info.case_images.json != null) {
          state.case_images = info.case_images.json.case_images;
        } else {
          state.case_images = info.case_images = {};
        }
      }

      state.case_history = info.case_history;
      console.log("[case history]", info.case_history);

      /* ************************************* CONVERTING A STRING FORMAT NOTE INTO AN ARRAY :( ************************************* */

      // let formatted_note_array = [];
      let note_per_line = JSON.parse(info.notes);

      /*var arrayLength = note_per_line.length;
      for (var i = 0; i < arrayLength; i++) {
        
        let note_per_line_instance = note_per_line[i];
        let splitted_note_per_line = note_per_line_instance.split(" - ");

        let note_data_set = {};

        note_data_set.title = splitted_note_per_line[0];
        note_data_set.note = splitted_note_per_line[1];

        formatted_note_array.push(note_data_set);
      }*/

      /* ************************************* CONVERTING A STRING FORMAT NOTE INTO AN ARRAY :( ************************************* */

      if(info.notes) {
        state.notes = note_per_line;
      } else {
        state.notes = [];
      }
      
      return state;
    },


    /* ################################################ NOTES EVENTS ################################################ */

    setActiveNote(state, index) {
      var active_note = state.notes[index];

      state.title             = active_note.title
      state.note              = active_note.note
      state.activeNoteIndex   = index;
    },

    /* ---------------------------------- FUNCTION SEPARATOR ---------------------------------- */

    updateIsSeasonalIllness(state, value) {
      state.isSeasonalIllness = value
    },

    /* ---------------------------------- FUNCTION SEPARATOR ---------------------------------- */

    updateNote(state, note) {
      state.note = note
    },

    /* ---------------------------------- FUNCTION SEPARATOR ---------------------------------- */

    updateTitle(state, title) {
      state.title = title
    },

    /* ---------------------------------- FUNCTION SEPARATOR ---------------------------------- */

    addNote(state) {
      var note = {
        title: state.title,
        note: state.note,
      }

      state.notes.push(note);
    },

    /* ---------------------------------- FUNCTION SEPARATOR ---------------------------------- */

    clearNote(state) {
      state.title = ''
      state.note = ''
    },

    /* ---------------------------------- FUNCTION SEPARATOR ---------------------------------- */
    
    editNote(state) {
      state.notes[state.activeNoteIndex].title = state.title;
      state.notes[state.activeNoteIndex].note = state.note;
    },

    /* ---------------------------------- FUNCTION SEPARATOR ---------------------------------- */

    removeNote(state) {
      state.notes.splice(state.activeNoteIndex, 1);
    },

    /* ---------------------------------- FUNCTION SEPARATOR ---------------------------------- */

    pushNote(state, allergy) {
      state.notes.push(allergy);
    },

    /* ################################################ NOTE EVENTS ################################################ */



    // case info
    updateReason(state, reason) {
      state.reason = reason
    },

    updateCategory(state, case_category) {
      state.case_category = case_category
    },

    updateCaseSubCategory(state, case_sub_category) {
      state.case_sub_category = case_sub_category
    },

    updateCaseCategoryComments(state, caseCategoryComments) {
      state.caseCategoryComments = caseCategoryComments
    },

    updateEndorsement(state, endorsement) {
      state.endorsement = endorsement
    },

    updateHistory(state, history) {
      state.history = history
    },

    clearStoreData(state) {
      state.cases = [];
      state.case_images = null;
      state.case = null;
      state.activeInfo = null;
      state.reason = '';
      state.case_category = '';
      state.pediatric_category = null;
      state.endorsement = '';
      state.history = ''
    },

    pushNewCase(state, { data, index}) {
      if (!index) {
        var key = data.consultations.length - 1
        data.consultation_call_datetime = data.consultations[key].call_datetime
        state.cases.unshift(data);
      }
      else {
        state.cases.splice(index, 0, data)
      }
    },

    removeCase(state, id) {
      var index = state.cases.findIndex((c) => c.id == id);
      state.cases.splice(index, 1);
    },

    setLastPage(state, page) {
      state.last_page = page
    }
  },

  /* ---------------------------------------------------------------- FUNCTION SEPARATOR ---------------------------------------------------------------- */

  actions: {
    // returns case
    async getCase(state, id) {
      var response = await Cases.get(id);
      return response.data
    },

    /* #################################### API CALL SEPARATOR #################################### */

    // returns case
    async getImageToken(state, case_number) {
      console.log("dispatcher");
      console.log(case_number);
      let response = await Cases.getImageToken(case_number);
      console.log(response);
    },

    /* #################################### API CALL SEPARATOR #################################### */
    
    async fetchCases(state, {id='', status=null, no_doctor=null, page=null}) {
      var response = await Cases.get(id, no_doctor, status, page);
      let sortedCases = response.data.data.sort(
        (a,b) => a.preferred_datetime.valueOf() - b.preferred_datetime.valueOf()
      )
      state.commit('setCases', sortedCases)
      state.commit('setLastPage', response.data.last_page)
    },

    /* #################################### API CALL SEPARATOR #################################### */

    async fetchCasesConsultation(state, {id='', status=null, no_doctor=null, page=null}) {
      var response = await Cases.get(id, no_doctor, status, page);
      let cases = response.data.data;
      cases.forEach(item => {
        let index = item.consultations.length - 1; // latest or most recent
        item.consultation_call_datetime = item.consultations[index].call_datetime
      });
      let sortedCases = cases.sort(
        (a,b) => a.consultation_call_datetime.valueOf() - b.consultation_call_datetime.valueOf()
      )
      state.commit('setCases', sortedCases)
      state.commit('setLastPage', response.data.last_page)
    },

    /* #################################### API CALL SEPARATOR #################################### */

    async fetchPatientCases(state, {id, per_page}) {
      var response = await Cases.getByPatientId(id, per_page);
      console.log("all cases by patient");
      console.log(response.data.data);
      return response.data.data;
    },

    /* #################################### API CALL SEPARATOR #################################### */

    async fetchCase(state, id) {
      var response = await Cases.get(id);
      state.commit('setCase', response.data);
    },

    /* #################################### API CALL SEPARATOR #################################### */

    async save({state, getters}, {caseId, full_payload}) {
      const payload = {
        last_menstrual_period:            getters.last_menstrual_period,
        health_concern:                   getters.health_concern,
        reason_for_encounter:             getters.reason,
        endorsement:                      getters.endorsement,        
        case_category:                    getters.case_category,
        case_sub_category:                getters.case_sub_category,
        caseCategoryComments:             getters.caseCategoryComments,
        notes:                            getters.notes,
        historyOfPresentIllness:          getters.history,
        isSeasonalIllness :               getters.isSeasonalIllness,
        medicalCertificateQuantity:       getters.medicalCertificateQuantity,
        full_payload:                     full_payload
      }

      let response = await Cases.update(caseId, payload);

      let pms_sync_errors = [];
      for (var key in response.data.pms_sync_response) {
        console.log(typeof response.data.pms_sync_response[key]);
        if(typeof response.data.pms_sync_response[key] === 'string') {
          pms_sync_errors.push({key, 'error' : JSON.parse(response.data.pms_sync_response[key]) });
        }
      }

      console.log("[errors here]", state.pms_sync_errors);
      console.log("[cases/save]", response);

      if(full_payload.consultation_status == "submitted") {
        let return_data = [
          {'has_pms_error' : response.data.has_pms_error},
          pms_sync_errors,
          response
        ]

        return return_data;
      } else {
        return response;
      }
    },

    /* #################################### API CALL SEPARATOR #################################### */

    async removeAssign(state, id) {
      const payload = {
        doctor_id: null
      }
      let response = await Cases.update(id, payload);
      console.log("[cases/removeAssign]", response);
    },

    /* #################################### API CALL SEPARATOR #################################### */
    
    /**
     * Save case status
     * 1. Complete  - case ongoing / consultation complete
     * 2. Save only - case ongoing / consultation ongoing
     * 3. For Transfer - case pending / consultation pending
     */
    async updateStatus(state, {id, status}) {
      const payload = {
        status: status
      }
      if (status == 'pending')
        payload.doctor_id = null
      let response = await Cases.update(id, payload);
      console.log("[cases/updateStatus]", response);
    },

    /* #################################### API CALL SEPARATOR #################################### */

    // API V2
    async fetchCasesV2(state, {id='', status=null, no_doctor=null, page=null}) {
      var response = await CasesV2.get(id, no_doctor, status, page);
      let sortedCases = response.data.data.sort(
        (a,b) => a.preferred_datetime.valueOf() - b.preferred_datetime.valueOf()
      )
      state.commit('setCases', sortedCases)
      state.commit('setLastPage', response.data.last_page)
    },

    /* #################################### API CALL SEPARATOR #################################### */

    async fetchPatientCasesV2(state, {id, per_page}) {
      var response = await CasesV2.getByPatientId(id, per_page);
      return response.data.data;
    },

    /* #################################### API CALL SEPARATOR #################################### */

    async fetchCaseV2(state, id) {
      var response = await CasesV2.get(id);
      console.log("retrieved case_data");
      console.log(response);
      state.commit('setCase', response.data);
    },

    /* #################################### API CALL SEPARATOR #################################### */

    async sendPdf(state, { consultationRequestId }) {
      console.log({consultationRequestId})
      await Cases.sendPdf(consultationRequestId)
        .then(response => {
          console.log({ response }, "cases response")
        })
        .catch(error => {
          console.log({ error }, "cases error")
        })
    },

    /* #################################### API CALL SEPARATOR #################################### */

    async getImages(state, id) {
      var response = await Cases.getImage(id);
      return response.data;
    }
  }
})